export default {
  data() {
    return {
      statusList: {
        0: {
          title: this.$t('lottery_list.status.ready'),
          color: '#239AF5',
        },
        1: {
          title: this.$t('lottery_list.status.no_win'),
          color: '#969799',
        },
        2: {
          title: this.$t('lottery_list.status.win'),
          color: '#F8C11C',
        },
        3: {
          title: this.$t('lottery_list.status.has_change'),
          color: '#969799',
        }
      },
    }
  },
  methods: {
    getStatusColor(item) {
      return {color: this.statusList[item.status].color};
    },
    getStatusTitle(item) {
      // 0 未开奖 1 未中奖 2 已中奖 3 已兑换
      return this.statusList[item.status].title;
    },
  }
}
